import Image from 'next/image';

import type { ProductTypeOptions } from '@/types/product';

import { getProductPlaceholderImage } from '@/components/ImagePlaceholder/helpers';
import { useImageLoader } from '@/hooks/useImageLoader';
import type { WithHTMLProp } from '@/lib/types';

import * as S from './ImagePlaceholder.styles';

export interface ImagePlaceholderProps extends WithHTMLProp<'className'> {
  productType?: ProductTypeOptions;
  sizes?: string;
  withBackground?: boolean;
}

export const ImagePlaceholder = ({
  className,
  productType,
  sizes = '100vw',
  withBackground = true,
}: ImagePlaceholderProps) => {
  const placeholderImage = getProductPlaceholderImage(productType);
  const { loader } = useImageLoader();

  return (
    <S.Placeholder
      className={className}
      data-test-id='ImagePlaceholderPlaceholder'
      data-testid='imagePlaceholder'
      withBackground={withBackground}
    >
      {placeholderImage ? (
        <Image
          alt={`${productType} placeholder`}
          data-testid='ImagePlaceholderLogo'
          height={0}
          loader={loader}
          sizes={sizes}
          src={placeholderImage}
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            maxHeight: '100%',
          }}
          width={0}
        />
      ) : (
        <S.Logo data-testid='ImagePlaceholderLogo' />
      )}
    </S.Placeholder>
  );
};

ImagePlaceholder.displayName = 'ImagePlaceholder';
